import { useEffect, useContext } from 'react';
import { useConfigService, ExperienceContext } from '@thd-nucleus/experience-context';

const GOOGLE_GARDEN_URL_PATH = '/commerce-sales-agent/get-token';
export const useGoogleGardenAgent = () => {
  const { hosts } = useContext(ExperienceContext);
  const GOOGLE_GARDEN_SCRIPT_SRC = useConfigService('google_garden_agent_script_url');
  const fsEnableGoogleGardenAgent = useConfigService('google_garden_agent_enable');
  const gardenAgentApiKey = useConfigService('google_garden_agent_apikey');
  const googleGardenTokenKey = useConfigService('google_garden_agent_token_key');
  const GOOGLE_GARDEN_AGENT_ENTRY_PAGE_IDS = useConfigService('google_garden_agent_entry_pageids') || [];

  useEffect(() => {
    const pagePathSegments = typeof window !== 'undefined' ? window.location.pathname.split('/') : [];
    const pageId = pagePathSegments[pagePathSegments?.length - 1];
    const loadGoogleGardenAgent = fsEnableGoogleGardenAgent && GOOGLE_GARDEN_AGENT_ENTRY_PAGE_IDS.includes(pageId);

    const handleGoogleAgentLoaded = async () => {
      try {
        const endpoint = `${hosts.apionline}${GOOGLE_GARDEN_URL_PATH}?key=${googleGardenTokenKey}`;
        // Fetch session id from endpoint
        const response = await fetch(endpoint);
        if (!response.ok) {
          throw new Error(`Error fetching session ID: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        const sessionId = data.sessionId;
        const token = data.token;

        if (sessionId && window.googleAgent) {
          window.googleAgent.setSessionId(sessionId);
        }
        if (token && window.googleAgent) {
          window.googleAgent.setToken(token);
        }
      } catch (error) {
        console.error('Error setting up Google Agent session:', error);
      }
    };
    let googleGardenScriptLoaded = {};
    if (!window.googleAgentSettings && loadGoogleGardenAgent) {
      // Set up Google Agent settings
      window.googleAgentSettings = {
        id: 'js7812siwvz02nQa',
        apiKey: gardenAgentApiKey
      };

      const scripts = Array.from(document.getElementsByTagName('script'));
      googleGardenScriptLoaded = scripts.find((script) => script.getAttribute('src') === GOOGLE_GARDEN_SCRIPT_SRC);

      if (!googleGardenScriptLoaded) {
        const script = document.createElement('script');
        script.src = GOOGLE_GARDEN_SCRIPT_SRC;
        script.type = 'text/javascript';
        script.async = true;
        script.onload = () => {
          // Add event listener for google-agent-loaded
          window.addEventListener('google-agent-loaded', handleGoogleAgentLoaded);
        };
        document.head.insertBefore(script, document.head.firstChild);
      } else {
        window.addEventListener('google-agent-loaded', handleGoogleAgentLoaded);
      }
    }

    return () => {
      if (googleGardenScriptLoaded?.parentNode) {
        googleGardenScriptLoaded.parentNode.removeChild(googleGardenScriptLoaded);
      }
      window.removeEventListener('google-agent-loaded', handleGoogleAgentLoaded);
    };

  }, [fsEnableGoogleGardenAgent, GOOGLE_GARDEN_AGENT_ENTRY_PAGE_IDS]);

  const openChat = () => {
    const messengerBubble = document.querySelector('chat-messenger-chat-bubble');
    if (messengerBubble) {
      messengerBubble.openChat();
    }
  };

  return [
    openChat
  ];
};